import { ValueConnector } from './calculation-classes';
import { CoordinatorService } from './coordinator.service';
import { ValueItem } from './value-item';
import { ValueItemStorage } from './value-item-storage';
import { ValueItemTemplate } from './value-item-template';

export class ValueItem$ {
    private _valueItemMap = new Map<string, ValueItem>();
    private _xitemId2valueItemLsMap = new Map<string, ValueItem[]>();

    private _valueItemTemplateMap = new Map<string, ValueItemTemplate>();
    private _valueItemStorageMap = new Map<string, ValueItemStorage>();

    private _currentTemplate?: ValueItemTemplate | undefined;

    constructor(public coords: CoordinatorService) {}

    public get currentTemplate(): ValueItemTemplate | undefined {
        try {
            if (!this._currentTemplate)
                this._currentTemplate = this._valueItemTemplateMap.values().next().value;
            return this._currentTemplate;
        } catch (e) {
            return undefined;
        }
    }
    public set currentTemplate(value: ValueItemTemplate | undefined) {
        this._currentTemplate = value;
        this.coords.display$.markForCheck();
    }

    templateByName(tag: string) {
        tag = this.coords.utils$.normalizeString(tag);
        for (const t of this._valueItemTemplateMap.values()) {
            if (tag === this.coords.utils$.normalizeString(t.title)) return t;
        }
        return;
    }

    clear() {
        this._valueItemMap.clear();
        this._xitemId2valueItemLsMap.clear();
        this._valueItemTemplateMap.clear();
        this._valueItemStorageMap.clear();
        this._currentTemplate = undefined;
    }

    get valueItemLs() {
        return Array.from(this._valueItemMap.values());
    }

    addItem(vitm: ValueItem) {
        this._valueItemMap.set(vitm.id, vitm);
        const xitmMp = this._xitemId2valueItemLsMap;
        let ls = xitmMp.get(vitm.itemId);
        if (!ls) {
            ls = [];
            xitmMp.set(vitm.itemId, ls);
        }
        ls.push(vitm);
        this.coords.display$.markForCheck();
    }

    get templateLs() {
        return Array.from(this._valueItemTemplateMap.values());
    }

    load3(ls: any[]) {
        ls.forEach((x) => {
            if (!x) return;
            try {
                const t = new ValueItemTemplate(this.coords, x.valueItemTemplate);
                this.addTemplate(t);
            } catch (e) {
                this.coords.utils$.consoleError('LOAD3 VI-TEMPLATE', e);
            }
        });
    }
    load3storage(ls: any[]) {
        ls.forEach((x) => {
            if (!x?.valueItemStorage?.valueItemLs?.length) return;
            try {
                // console.log('VITM STORAGE', x);
                x.valueItemStorage.valueItemLs.forEach((vitmParams: any) => {
                    if (!this._valueItemTemplateMap.has(vitmParams.templateId)) return;
                    const vitm = new ValueItem(this.coords, vitmParams);
                    // console.log('VITM', vitm);
                    this.addItem(vitm);

                    if (!this.getStorage(vitm.templateId)) {
                        const storage = new ValueItemStorage(this.coords, {
                            id: x.valueItemStorage.id,
                            templateId: vitm.templateId,
                        });
                        this._valueItemStorageMap.set(vitm.templateId, storage);
                    }

                    this.storeValueItem(vitm, true);
                });
                // const t = new ValueItemTemplate(this.coords, x.valueItemTemplate);
                // this.addTemplate(t);
            } catch (e) {
                this.coords.utils$.consoleError('LOAD3 VI-STORAGE', e);
            }
        });
    }

    addTemplate(vitTemplate: ValueItemTemplate) {
        this._valueItemTemplateMap.set(vitTemplate.id, vitTemplate);
        this.coords.display$.markForCheck();
    }

    xitemValueConnector(xitmId: string) {
        const ls = this._xitemId2valueItemLsMap.get(xitmId);
        return new ValueConnector(this.coords, ls);
    }

    getValueItemInstance({
        itemId,
        ownerId,
        templateId,
    }: {
        itemId: string;
        templateId: string;
        ownerId?: string;
    }) {
        if (!ownerId) ownerId = this.coords.user$.currentId || '_unlogged';

        const ls = this._xitemId2valueItemLsMap.get(itemId);
        if (!ls) return undefined;

        for (let vitm of ls) {
            if (vitm.templateId === templateId && vitm.ownerId === ownerId) return vitm;
        }
        return undefined;
    }

    get(vitmId: string) {
        return this._valueItemMap.get(vitmId);
    }

    getTemplate(templateId: string) {
        return this._valueItemTemplateMap.get(templateId);
    }

    getStorage(templateId: string) {
        return this._valueItemStorageMap.get(templateId);
    }

    storeValueItem(vitm: ValueItem, isLoad = false) {
        let storage = this.getStorage(vitm.templateId);
        if (!storage) {
            storage = new ValueItemStorage(this.coords, {
                templateId: vitm.templateId,
            });
            this._valueItemStorageMap.set(vitm.templateId, storage);
        }
        storage.update(vitm, isLoad);
    }

    createTemplate() {
        const t = new ValueItemTemplate(this.coords, {});
        return t;
    }
    deleteTemplate(t: ValueItemTemplate) {
        this._valueItemTemplateMap.delete(t.id);
        this.coords.display$.markForCheck();
    }

    editDialog(template?: ValueItemTemplate) {
        this.coords.display$.dialog$.next({
            action: 'values-editor',
            template,
        });
    }

    get sortedList() {
        const ls = Array.from(this._valueItemTemplateMap.values());
        ls.sort((a, b) => (a.title?.toLowerCase() < b.title?.toLowerCase() ? -1 : 1));
        return ls;
    }
}
